import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import UpdateStatus from '@/views/updateStatus.vue'

const routes = [
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: { 
          icon: 'pi pi-home',
          label: 'Tableau de bord'
        }
      },
      {
        path: 'suppliers',
        name: 'Suppliers',
        component: () => import('@/views/updateFournisseur.vue'),
        meta: {
          icon: 'pi pi-users',
          label: 'Fournisseurs'
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '/update-status',
    name: 'UpdateStatus',
    component: UpdateStatus,
  },
 
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      // Redirect to login if not authenticated
      next({ name: 'Login' })
    } else {
      next()
    }
  } 
  // Redirect to dashboard if authenticated and trying to access guest routes
  else if (to.matched.some(record => record.meta.guest) && token) {
    next({ name: 'Dashboard' })
  } 
  else {
    next()
  }
})

export default router